/* global Swiper */

export default {
  init() {
    const offersSliderBlock = $('.offers-slider-block');
    if (offersSliderBlock.length) {
      const swiperContainer = offersSliderBlock.find('.swiper-container').get(0);
      const slides = offersSliderBlock.find('.swiper-slide');

      if (swiperContainer && slides.length > 1) {
        new Swiper(swiperContainer, {
          loop: false,
          autoplay: false,
          slidesPerView: 1,
          navigation: {
            nextEl: offersSliderBlock.find('.swiper-button-next').get(0),
            prevEl: offersSliderBlock.find('.swiper-button-prev').get(0),
          },
        });
      }
    }
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/acf-blocks/offersSlider.js